import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetAllStates = () => {
  const get = useTypedApiClient({
    path: '/admin/states',
    method: 'get',
  })

  return useQuery({
    queryKey: ['/admin/states'],
    queryFn: async () => {
      const { data } = await get({})
      return data
    },
  })
}
